import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

export default function Login() {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(formData.email, formData.password);
      toast.success('Login berhasil!');
      navigate('/');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Terjadi kesalahan');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-red-600 to-red-800 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/hisana-logo.png" alt="Hisana" className="h-28 mx-auto mb-4 drop-shadow-lg" />
          <h1 className="text-3xl font-bold text-white mb-1" style={{ fontFamily: 'Manrope, sans-serif' }}>HISA</h1>
          <p className="text-red-100 text-sm" style={{ fontFamily: 'DM Sans, sans-serif' }}>Payment Gate System</p>
        </div>
        
        <Card className="shadow-2xl border-0 bg-white/95 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-2xl text-red-700" style={{ fontFamily: 'Manrope, sans-serif' }}>
              Login
            </CardTitle>
            <CardDescription>
              Masuk ke akun Anda
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  data-testid="login-email-input"
                  type="email"
                  placeholder="user@example.com"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  required
                />
              </div>
              
              <div className="space-y-2">
                <Label htmlFor="password">Password</Label>
                <Input
                  id="password"
                  data-testid="login-password-input"
                  type="password"
                  placeholder="••••••••"
                  value={formData.password}
                  onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                  required
                />
              </div>
              
              <Button
                data-testid="login-submit-button"
                type="submit"
                className="w-full bg-red-600 hover:bg-red-700"
                disabled={loading}
              >
                {loading ? (
                  <><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Loading...</>
                ) : (
                  'Login'
                )}
              </Button>
            </form>
          </CardContent>
        </Card>
        
        <p className="text-center text-red-200 text-xs mt-6">
          Hubungi Admin untuk pembuatan akun baru
        </p>
      </div>
    </div>
  );
}


